import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_19ve7j7a7y: FaireBrandEntity = {
  token: "b_19ve7j7a7y",
  type: "brand",
  name: "Intelligent Change",
  avatarUrl:
    "https://cdn.faire.com/fastly/95a297b1a23d889ae4a73c733d5e51ba64c3953fd51aedbf7218f60a2ebeeddb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/08b4f657421be8c5b8fc46b31c3effc13a80d1bfbabd13c7fe41b5d9baa69b1e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/95a297b1a23d889ae4a73c733d5e51ba64c3953fd51aedbf7218f60a2ebeeddb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/08b4f657421be8c5b8fc46b31c3effc13a80d1bfbabd13c7fe41b5d9baa69b1e.png",
  location: "Dover, DE, USA",
  minimumOrderDollars: 100,
  rating: 4.7,
  reviewCount: 67,
  isTopShop: true,
  isInsider: true,
  description:
    "Intelligent Change creates products that help you realize your potential and live a happier, more fulfilling life.\n\nOUR BELIEF\nYou can achieve more with less. We create products that are the simplest, most effective tools to help you realize your potential. Whether that is using The Five Minute Journal to bring gratitude into your life or the Productivity Planner to help you build the business you’ve always dreamed of. Our products will help you seamlessly create positive habits without investing years in experimenting and research to achieve the same results.\n\nWE ARE COMMITTED TO A BETTER FUTURE\nOur newest products use Shiro Echo carbon neutral, 100% recycled, biodegradable, and FSC™ certified paper by Favini. No trees were cut down to create virgin paper to make our products. Our journals are bound in 100% cloth based natural fabrics like cotton or linen that don’t contain synthetic materials such as polyester and plastic.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:43:53.772Z",
    importedBy: "entity-db-cli",
  },
};
